import { t } from "../../i18n";
import type { CaseId, CheckResult, WallResult } from "@tasduvar/engine";

const CASE_SHORT: Record<CaseId, () => string> = { static: () => t("Statik"), seismicUp: () => `${t("Deprem")} ↑`, seismicDown: () => `${t("Deprem")} ↓` };
/** Motorun allOk kuralı (analyze.ts): yönetmelik oranı + hüküm veren klasik GK */
const bad = (c: CheckResult): boolean => !(c.tbdy?.ok ?? true) || !(c.classic.informative === true || c.classic.ok);

/**
 * İlk sağlanmayan kontrol, kısa adıyla ("Kayma · Deprem ↑"); hepsi sağlanıyorsa null. Telefonda sonuç alt sayfasının
 * başlığında hüküm hemen okunsun diye (tablo kaydırılmadan).
 */
export function firstFailure(r: WallResult): string | null {
  for (const id of ["static", "seismicUp", "seismicDown"] as CaseId[]) {
    const c = r.cases[id];
    if (!c || c.allOk) continue;
    const at = ` · ${CASE_SHORT[id]()}`;
    if (bad(c.overturning)) return t("Devrilme") + at;
    if (bad(c.sliding)) return t("Kayma") + at;
    if (!c.eccentricity.ok) return t("Dış merkezlilik") + at;
    if (bad(c.bearing)) return t("Taşıma gücü") + at;
  }
  const j = r.joints.find((x) => !x.allOk);
  if (j) return `${t("Ara kesit")} ${j.label}`;
  if (r.rc && !r.rc.ok) return t("Betonarme kesit");
  return r.ok ? null : t("Sağlanmayan kontrol var");
}
